import { useState, useEffect } from "react";
import cx from "classnames";
import { func, string, object } from "prop-types";
import { navItemShape } from "../PrimaryNav/primaryNavTypes.js";
import Icon from "../../Icon/Icon.jsx";
import LinkDescriptionsMegaMenu from "../MegaMenu/LinkDescriptionsMegaMenu.jsx";
import CallToActionMegaMenu from "../MegaMenu/CallToActionMegaMenu.jsx";
import FeaturedContentMegaMenu from "../MegaMenu/FeaturedContentMegaMenu.jsx";

const propTypes = {
  item: navItemShape.isRequired,
  childMenuOpen: string,
  setChildMenuOpen: func,
  menuItemDimensions: object,
};

const MobileMenuItem = (props) => {
  const [customStyles, setCustomStyles] = useState({});
  const {
    item,
    childMenuOpen,
    setChildMenuOpen,
    menuItemDimensions,
    ...otherProps
  } = props;

  const returnToPreviousScreen = () => {
    setChildMenuOpen("");
  };

  const handleForOpen = (label) => {
    setChildMenuOpen(label);
  };

  useEffect(() => {
    setCustomStyles({
      height: `calc(100vh - ${menuItemDimensions.height}px)`,
      top: `${menuItemDimensions.height}px`,
    });
  }, [menuItemDimensions]);

  return (
    <li
      {...otherProps}
      className={cx("mobile-menu__item", {
        "mobile-menu__item--open": childMenuOpen,
      })}
    >
      <button
        type="button"
        className={cx(
          "primary-nav__item--mobile",
          "mobile-menu__accordion-trigger",
          {
            "mobile-menu__accordion-trigger--open":
              item.children && item.children.length > 0 && childMenuOpen,
          },
        )}
        onClick={() => handleForOpen(item.title)}
      >
        {item.title}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.2091 8.49657C10.2493 8.4524 10.2848 8.40304 10.3096 8.34783C10.3699 8.23741 10.4 8.12179 10.4 8.00032C10.4 7.87886 10.3699 7.76259 10.3143 7.65737C10.2889 7.60281 10.2541 7.5528 10.2145 7.50278L7.14967 4.14079C6.97888 3.95307 6.7029 3.95307 6.53211 4.14079C6.356 4.3285 6.356 4.63248 6.53211 4.8202L9.41579 8L6.53211 11.1804C6.356 11.3682 6.356 11.6715 6.53211 11.8592C6.7029 12.0469 6.97888 12.0469 7.14967 11.8592L10.2091 8.49657Z"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.25"
          />
        </svg>
      </button>

      <LinkDescriptionsMegaMenu
        item={item}
        className={cx(
          "link-descriptions__dropdown link-descriptions__mobile-menu mobile-menu__child-menu",
          {
            "mobile-menu__child-menu--open":
              item.menuType === "Link Descriptions" &&
              childMenuOpen === item.title,
          },
        )}
        returnToPreviousScreen={returnToPreviousScreen}
        style={customStyles}
      />

      <CallToActionMegaMenu
        item={item}
        className={cx("call-to-action__dropdown mobile-menu__child-menu", {
          "mobile-menu__child-menu--open":
            item.menuType === "Call to Action" && childMenuOpen === item.title,
        })}
        returnToPreviousScreen={returnToPreviousScreen}
        style={customStyles}
      />
      <FeaturedContentMegaMenu
        item={item}
        parentClasses={cx(
          "featured-content__dropdown mobile-menu__child-menu",
          {
            "mobile-menu__child-menu--open":
              item.menuType === "Featured Content" &&
              childMenuOpen === item.title,
          },
        )}
        returnToPreviousScreen={returnToPreviousScreen}
        menuItemDimensions={menuItemDimensions}
        style={customStyles}
      />
    </li>
  );
};

MobileMenuItem.propTypes = propTypes;
export default MobileMenuItem;
